import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import { getAccountInitials } from "@syla/shared/types/models/AccountAccessBase";
import { AccountAccessDetails } from "@syla/shared/types/responses/GetAccountsResponse";
import React from "react";
import { AccountTypeBadgeColorMap } from "./AccountTypeBadgeColorMap";

export type AccountStaticOptionContentProps = {
  account: AccountAccessDetails;
};

export function AccountStaticOptionContent({
  account,
}: AccountStaticOptionContentProps) {
  return (
    <Flex w="full" minW={0} alignItems="center" color="gray.700" gap={2}>
      <Flex
        flexShrink={0}
        h="2.4rem"
        w="2.4rem"
        rounded="md"
        align="center"
        justify="center"
        backgroundColor="gray.100"
        borderWidth="1px"
        borderColor="gray.300"
      >
        <Text fontSize="xs" fontWeight="bold">
          {getAccountInitials({ fullName: account.fullName })}
        </Text>
      </Flex>

      <Box minW={0} alignItems="flex-start" flexGrow={1}>
        {account.fullName && (
          <Text width="full" fontWeight="semibold" fontSize="md">
            {account.fullName}
          </Text>
        )}

        {account.nickname && (
          <Text width="full" fontSize="sm" fontWeight="light" color="gray.600">
            {account.nickname}
          </Text>
        )}
      </Box>

      <Badge
        flexShrink={0}
        colorScheme={AccountTypeBadgeColorMap[account.accountType]}
      >
        {account.accountType}
      </Badge>
    </Flex>
  );
}
